import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'suffixDate',
  standalone: true,
  pure: false
})
export class SuffixDatePipe implements PipeTransform {
  constructor(private translate: TranslateService) {}

  transform(day: number): string {
    if (day < 1 || day > 31) {
      return '';
    }

    if (this.translate.currentLang === ('es-es.ENDESA')
      || this.translate.currentLang === ('es-es.AGORA')
      || this.translate.currentLang === ('es-es.ENELX')
      || this.translate.currentLang === ('ct-es.ENDESA')
      || this.translate.currentLang === ('ct-es.AGORA')
      || this.translate.currentLang === ('ct-es.ENELX')) {
      return `${day}`;
    }

    let suffix = 'th';
    if (day % 10 === 1 && day % 100 !== 11) {
      suffix = 'st';
    } else if (day % 10 === 2 && day % 100 !== 12) {
      suffix = 'nd';
    } else if (day % 10 === 3 && day % 100 !== 13) {
      suffix = 'rd';
    }

    return `${day}${suffix}`;
  }
}
